// extracted by mini-css-extract-plugin
export var contentfulTooltip = "-4jpp";
export var contentfulTooltipBody = "mYPhC";
export var contentfulTooltipTitle = "lojPQ";